import React from 'react';
import { GiPlainSquare } from 'react-icons/gi';
import { MdArrowOutward } from 'react-icons/md';
import builders from "../../Assets/0002.webp";
import { FaCheckCircle } from "react-icons/fa";
import { GoArrowRight } from "react-icons/go";
import { useNavigate } from 'react-router-dom';

const Trust = () => {
  const navigate = useNavigate()

  return (
    <div className="relative flex flex-col lg:flex-row max-w-screen-2xl mx-auto items-center lg:items-start px-6 lg:px-0">
      
      {/* Left Green Section */}
      <div className="w-full lg:w-[20%] bg-[#068b07] min-h-[480px] flex items-center justify-center relative py-8 lg:py-0">
        {/* Black Card Box */}
        <div className="bg-black opacity-85 absolute left-6 lg:left-16 top-9 md:top-20  p-6 lg:p-8 w-[80%] sm:w-[60%] lg:w-[75%] z-30">
          <p className="text-white text-sm leading-relaxed">
            Passion. Integrity. Hard work. Professionalism. Take care of. That is the value that we have been building our brand.
          </p>
          <div className="flex justify-end mt-3">
            <GoArrowRight className="text-white"size={20} />
          </div>
        </div>
        <img 
          src={builders} 
          alt="builders" 
          className="h-[280px] sm:h-[320px] md:h-[350px] lg:h-[380px] md:-right-56 absolute w-auto object-contain z-20 mt-8 lg:mt-0"
        />
      </div>
      {/* Image Section */}
      <div className="w-full lg:w-[30%] relative flex justify-center lg:justify-start  ">
      
      </div>
      {/* Right Content Section */}
      <div className="w-full lg:w-[50%] flex flex-col space-y-5 my-5 px-4 lg:px-0">
        
        {/* Header */}
        <div className="flex items-center space-x-2 mt-3 justify-center lg:justify-start">
          <GiPlainSquare className="text-[#068b07]" size={16} />
          <p className="text-gray-500 font-medium text-sm">Construction Experience</p>
        </div>

        {/* Title & Description */}
        <div className="text-center lg:text-left">
          <h1 className="font-bold text-2xl md:text-4xl leading-snug">
            Trusted Company <br /> to Build your Dream Home
          </h1>
          <p className="text-gray-500 font-medium text-sm md:text-base mt-3 leading-relaxed">
            We are a leading national industrial, multi-family, and commercial building company that has been turning clients’ visions into realities for over 35 years. Opportunities for professional growth are presented each day, and we are dedicated to providing the safest and most productive working environment possible.
          </p>
        </div>

        {/* Tick List */}
        <div className="space-y-3">
          {[
            "Regularly Maintaining and Organizing your Tools",
            "Experienced Construction Professional",
            "Innovative Eco Power Technologies",
          ].map((item, index) => (
            <div key={index} className="flex items-center space-x-2">
              <FaCheckCircle className="text-[#068b07]" size={18} />
              <span className="font-semibold text-sm md:text-md">{item}</span>
            </div>
          ))}
        </div>

        {/* Button Section */}
        <div className="flex justify-center mb-2 lg:justify-start">
          <button className="flex gap-2 bg-[#068b07] text-white font-medium px-6 py-3  hover:bg-[#057a06] transition duration-300" onClick={() => navigate('/services')}>
            <span>View All Services</span>
            <MdArrowOutward className="bg-[#121315] text-white p-1   size-5 md:size-6" />
          </button>
        </div>

      </div>
    </div>
  );
};

export default Trust;
